module.exports = __webpack_public_path__ + "img/hej-th.c87e3cea.png";